import { ComponentStore } from '@ngrx/component-store'

export interface State {
  /**
   * Whether the overflow currently open
   */
  presentOverflow?: boolean
}
/** TODO:  */
export class Store extends ComponentStore<State> {
  /** @see {@link State.presentOverflow}*/
  public readonly presentOverflowSg = this.selectSignal(
    state => state.presentOverflow,
  )

  constructor() {
    super({
      presentOverflow: false,
    })
  }
}
